import moment from 'moment';
import * as R from 'ramda';
import angular from 'angular';


export default function EditAuditDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  markAuditCompleteConfirmDialog,
  amDataService,
  loaderService,
  selectAgencyDialog,
  ssDialogService
) {
  const vm = this;

  if (!R.isNil(this.audit.startDate)) {
    vm.startDate = moment(this.audit.startDate);
  }
  if (!R.isNil(this.audit.preparationItemsDefaultDueDate)) {
    vm.preparationItemsDefaultDueDate = moment(this.audit.preparationItemsDefaultDueDate);
  }
  if (!R.isNil(this.audit.findingsDefaultDueDate)) {
    vm.findingsDefaultDueDate = moment(this.audit.findingsDefaultDueDate);
  }
  if (!R.isNil(this.audit.onsiteDate)) {
    vm.onsiteDate = moment(this.audit.onsiteDate);
  }
  if (!R.isNil(this.audit.findingRemediationStartDate)) {
    vm.findingRemediationStartDate = moment(this.audit.findingRemediationStartDate);
  }
  if (!R.isNil(this.audit.recommendationsDefaultDueDate)) {
    vm.recommendationsDefaultDueDate = moment(this.audit.recommendationsDefaultDueDate);
  }

  vm.isActive = false;

  if (this.audit.isActive !== null) {
    vm.isActive = this.audit.isActive;
  }

  vm.handleSelectAgency = handleSelectAgency;
  vm.handleCloseDialog = handleCloseDialog;
  vm.handleAddAuditFormSubmit = handleAddAuditFormSubmit;
  vm.handleExpandSection = handleExpandSection;
  vm.isValidControl = isValidControl;

  _initEventListeners();

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function handleSelectAgency($event) {
    _showSelectAgencyDialog($event);
  }

  function handleCloseDialog() {
    $rootScope.$broadcast('refreshAMAudits');
    _closeDialog();
  }

  function handleAddAuditFormSubmit() {
    console.log(`handleAddAuditFormSubmit: scope.valid: ${$scope.amEditAuditForm.$valid}`);
    if ($scope.amEditAuditForm.$valid) {
      loaderService.showViewLoader = true;
      _saveAudit().then(() => {
        loaderService.showViewLoader = false;
      });
    }
  }

  function handleExpandSection($event, section) {
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }

  function isValidControl(ctrl) {
    return ($scope.amEditAuditForm)
      && (($scope.amEditAuditForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    loaderService.showViewLoader = false;
    if (vm.refreshAudit && vm.audit.auditId > 0) {
      // Get this audit's coordinatorName from vm.coordinators
      angular.forEach(vm.coordinators, (item) => {
        if (item.userId === vm.audit.coordinatorUserId) {
          vm.coordinatorName = item.fullName;
        }
      });
      
      // Set the Agency (if the agency is a deleted vendor)
      angular.forEach(vm.agencies, (item) => {
        if (item !== null) { 
          if ((item.agencyId === vm.audit.agencyId) && (vm.audit.agency == null)) {
            vm.audit.agency = item;
            vm.audit.agencyName = item.name;
          }
        }
      });
    }
  }
  function _initEventListeners() {
    $scope.$on('closeEditAudit', () => { _closeDialog(); });
    $scope.$on('refreshAuditAgencies', _refreshAgencies);
  }

  function _saveAudit() {
    const dfdSave = $q.defer();
    const dfdHideDialog = $q.defer();

    if (_isValid()) {
      if (vm.isActive) {
        // Editing an active audit

        // Set the dates on audit object
        if (!R.isNil(vm.startDate)) {
          vm.audit.startDate = moment(vm.startDate);
        } else {
          vm.audit.startDate = null;
        }

        if (!R.isNil(vm.preparationItemsDefaultDueDate)) {
          vm.audit.preparationItemsDefaultDueDate = moment(vm.preparationItemsDefaultDueDate);
        } else {
          vm.audit.preparationItemsDefaultDueDate = null;
        }

        if (!R.isNil(vm.findingsDefaultDueDate)) {
          vm.audit.findingsDefaultDueDate = moment(vm.findingsDefaultDueDate);
        } else {
          vm.audit.findingsDefaultDueDate = null;
        }

        if (!R.isNil(vm.onsiteDate)) {
          vm.audit.onsiteDate = moment(vm.onsiteDate);
        } else {
          vm.audit.onsiteDate = null;
        }

        if (!R.isNil(vm.findingRemediationStartDate)) {
          vm.audit.findingRemediationStartDate = moment(vm.findingRemediationStartDate);
        } else {
          vm.audit.findingRemediationStartDate = null;
        }

        if (!vm.audit.agencyIsThirdParty) {
          vm.audit.agency = null;
          vm.audit.agencyId = 0;
        }

        if (!R.isNil(vm.recommendationsDefaultDueDate)) {
          vm.audit.recommendationsDefaultDueDate = moment(vm.recommendationsDefaultDueDate);
        } else {
          vm.audit.recommendationsDefaultDueDate = null;
        }

        if (vm.audit.isActive) {
          // We're just saving the audit, (not completing it)
          // Update the audit information
          amDataService.saveAudit(vm.audit).then((savedAuditResponse) => {
            const savedAudit = savedAuditResponse.data;
            if (savedAudit.auditId === 'undefined' || savedAudit.auditId <= 0) {
              // There was an error saving the audit information
              alerts.error('Error occurred while saving the Audit.');
              dfdSave.reject();
            } else {
              // The audit information has been saved
              vm.audit.auditId = savedAudit.auditId;
              alerts.success('The Audit has been saved successfully.');
              ssDialogService.hide(ssDialogService.dialogs.auditTrail.editAuditDialog).then(dfdHideDialog.resolve);
              $rootScope.$broadcast('refreshAMAudits');
            }
          });
        } else {
          // We are completing the audit. Go ahead and show the confirmation page.
          _openMarkCompleteConfirmation();
        }
      } else {
        // Editing a completed audit
        if (vm.audit.isActive) {
          // Reactivating the audit
          alerts.success('The Audit is being reopened.');
          amDataService.reopenAudit(vm.audit.auditId)
            .then((response) => {
              const savedAudit = response.data;
              if (savedAudit.auditId === 'undefined' || savedAudit.auditId <= 0) {
                alerts.error('Error occurred while reopening the Audit.');
                dfdSave.reject();
              } else {
                alerts.success('The Audit has been successfully reopened.');
                ssDialogService.hide(ssDialogService.dialogs.auditTrail.editAuditDialog)
                  .then(dfdHideDialog.resolve);
                $rootScope.$broadcast('refreshAMAudits');
              }
            });
        } else {
          // Leaving the audit as is - no need to perform a save.
          alerts.success('The Audit has been saved successfully.');
          ssDialogService.hide(ssDialogService.dialogs.auditTrail.editAuditDialog)
            .then(dfdHideDialog.resolve);
        }
      }
      dfdHideDialog.promise.then(dfdSave.resolve);
    } else {
      dfdSave.reject();
    }
    return dfdSave.promise;
  }

  // Expand/Collapse

  function _isValid() {
    let isValid = $scope.amEditAuditForm.$valid;

    if (!isValid) {
      isValid = true;
      angular.forEach($scope.amEditAuditForm.$error.parse, (item) => {
        if ((item.$name === 'addAuditStartDate') || (item.$name === 'addAuditPreparationItemsDefaultDueDate')
          || (item.$name === 'addAuditFindingsDefaultDueDate') || (item.$name === 'addAuditOnsiteDate')
          || (item.$name === 'addAuditFindingRemediationStartDate')) {
          if ((item.$modelValue !== null) && (!moment(item.$modelValue).isValid())) {
            isValid = false;
          }
        } else {
          isValid = false;
        }
      });
      angular.forEach($scope.amEditAuditForm.$error.pattern, () => {
        isValid = false;
      });
      angular.forEach($scope.amEditAuditForm.$error.required, () => {
        isValid = false;
      });
    }
    return isValid;
  }

  function _showSelectAgencyDialog($event) {
    loaderService.showViewLoader = true;
    ssDialogService.dialogs.auditTrail.selectAgencyDialog = ssDialogService.alert(
      selectAgencyDialog.getOptions($event, {
        audit: vm.audit,
        agencies: vm.agencies,
        auditTypes: vm.auditTypes,
        coordinators: vm.coordinators,
        dataTypes: vm.dataTypes,
        refreshAudit: false,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.selectAgencyDialog);
  }

  function _openMarkCompleteConfirmation($event) {
    loaderService.showViewLoader = true;
    ssDialogService.dialogs.amMarkAuditCompleteConfirmDialog = ssDialogService.alert(
      markAuditCompleteConfirmDialog.getOptions($event, {
        audit: vm.audit,
        agencies: vm.agencies,
        auditTypes: vm.auditTypes,
        coordinators: vm.applicationUsers,
        dataTypes: vm.dataTypes,
        refreshAudit: false,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.amMarkAuditCompleteConfirmDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.editAuditDialog);
  }

  function _refreshAgencies() {
    const dfdAgencies = $q.defer();
    loaderService.showViewLoader = true;
    amDataService.getAgencies().then((response) => {
      vm.agencies = response.data.result;

      let found = false;
      R.forEach((agency) => {
        if (agency.agencyId === vm.audit.agencyId) {
          found = true;
        }
      }, vm.agencies);

      if (!found) {
        vm.agencies.push(vm.audit.agency);
      }
      
      vm.agencies = R.sortBy(R.prop('name'), vm.agencies);


      loaderService.showViewLoader = false;
      dfdAgencies.resolve();
    });

    return dfdAgencies.promise;
  }
}

EditAuditDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'markAuditCompleteConfirmDialog',
  'amDataService',
  'loaderService',
  'selectAgencyDialog',
  'ssDialogService'
];
